<template>
  <div class="new-container">
    <div class="signup__card">
      <img
        v-show="shouldShowCompanyLogo() && !isAnonimous"
        :src="logo"
        alt="Company Logo"
        class="signup__card--logo"
      />
      <h2 v-show="isAnonimous">Empresa anônima</h2>
      <h4 class="signup__card--title">Inicie sua candidatura na Vaga</h4>
      <button
        class="signup__card--whatsapp"
        v-if="optimizelyIsEnabled()"
        @click="() => (popupActivity = !popupActivity)"
      >
        <div class="mr-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            width="18px"
            height="18px"
            viewBox="0 0 30.667 30.667"
            style="enable-background: new 0 0 30.667 30.667"
            xml:space="preserve"
            class=""
          >
            <g>
              <g>
                <path
                  d="M30.667,14.939c0,8.25-6.74,14.938-15.056,14.938c-2.639,0-5.118-0.675-7.276-1.857L0,30.667l2.717-8.017   c-1.37-2.25-2.159-4.892-2.159-7.712C0.559,6.688,7.297,0,15.613,0C23.928,0.002,30.667,6.689,30.667,14.939z M15.61,2.382   c-6.979,0-12.656,5.634-12.656,12.56c0,2.748,0.896,5.292,2.411,7.362l-1.58,4.663l4.862-1.545c2,1.312,4.393,2.076,6.963,2.076   c6.979,0,12.658-5.633,12.658-12.559C28.27,8.016,22.59,2.382,15.61,2.382z M23.214,18.38c-0.094-0.151-0.34-0.243-0.708-0.427   c-0.367-0.184-2.184-1.069-2.521-1.189c-0.34-0.123-0.586-0.185-0.832,0.182c-0.243,0.367-0.951,1.191-1.168,1.437   c-0.215,0.245-0.43,0.276-0.799,0.095c-0.369-0.186-1.559-0.57-2.969-1.817c-1.097-0.972-1.838-2.169-2.052-2.536   c-0.217-0.366-0.022-0.564,0.161-0.746c0.165-0.165,0.369-0.428,0.554-0.643c0.185-0.213,0.246-0.364,0.369-0.609   c0.121-0.245,0.06-0.458-0.031-0.643c-0.092-0.184-0.829-1.984-1.138-2.717c-0.307-0.732-0.614-0.611-0.83-0.611   c-0.215,0-0.461-0.03-0.707-0.03S9.897,8.215,9.56,8.582s-1.291,1.252-1.291,3.054c0,1.804,1.321,3.543,1.506,3.787   c0.186,0.243,2.554,4.062,6.305,5.528c3.753,1.465,3.753,0.976,4.429,0.914c0.678-0.062,2.184-0.885,2.49-1.739   C23.307,19.268,23.307,18.533,23.214,18.38z"
                  data-original="#000000"
                  class="active-path"
                  data-old_color="#000000"
                  fill="#FFFFFF"
                />
              </g>
            </g>
          </svg>
        </div>
        Cadastre-se com WhatsApp
      </button>
      <vs-divider style="margin: 0px 0px" v-if="optimizelyIsEnabled()" position="center">
        ou
      </vs-divider>
      <ValidationObserver
        ref="observer"
        tag="form"
        v-slot="{ invalid }"
        @submit.prevent="handleRegister()"
      >
        <ValidationProvider name="nome" rules="required|min:3" v-slot="{ errors }">
          <vs-input
            class="signup__card--input"
            icon="account_circle"
            v-model="username"
            :placeholder="$t('placeholders.username')"
            :label-placeholder="$t('placeholders.username')"
            :danger="Boolean(errors.length)"
            :danger-text="errors[0]"
          />
        </ValidationProvider>

        <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
          <vs-input
            class="signup__card--input"
            type="email"
            icon="email"
            v-model="email"
            :label-placeholder="$t('placeholders.email')"
            :placeholder="$t('placeholders.email')"
            :danger="Boolean(errors.length)"
            :danger-text="errors[0]"
          />
          <span class="text-danger text-sm">{{ api_callback_errors.email }}</span>
        </ValidationProvider>

        <ValidationProvider name="Confirmação de email" rules="required|email|confirmed:email" v-slot="{ errors }">
          <vs-input
            class="signup__card--input"
            type="email"
            icon="email"
            v-model="confirmEmail"
            :label-placeholder="$t('placeholders.confirmEmail')"
            :placeholder="$t('placeholders.confirmEmail')"
            :danger="Boolean(errors.length)"
            :danger-text="errors[0]"
          />
        </ValidationProvider>

        <VuePhoneNumberInput
          id="phonenumber"
          default-country-code="BR"
          v-model="telephone"
          valid-color="#000000"
          :style="{ opaticy: 0.2, marginTop: '15px' }"
          :translations="{
            countrySelectorLabel: 'Código',
            countrySelectorError: 'Selecione um País',
            phoneNumberLabel: 'Número de Telefone',
            example: 'Exemplo:',
          }"
        />

        <vs-input
          class="w-full no-icon-border mb-1"
          name="cpf"
          type="text"
          icon="verified_user"
          :style="{ marginTop: '15px', zIndex: 0 }"
          v-mask="'###.###.###-##'"
          placeholder="CPF (Somente números)"
          data-vv-validate-on="blur"
          v-validate="'required|cpf'"
          v-if="optimizelyIsEnabledSsn()"
          v-model="ssn"
          required
        />
        <span class="text-danger text-sm">{{ api_callback_errors.ssn }}</span>

        <ValidationProvider
          vid="senha"
          name="senha"
          rules="required|min:8"
          v-slot="{ errors }"
        >
          <vs-input
            class="signup__card--input"
            icon="https"
            :type="!showPassword ? 'password' : 'text'"
            v-model="password"
            :style="{ zIndex: 0 }"
            :placeholder="$t('placeholders.password')"
            :label-placeholder="$t('placeholders.password')"
            :danger="Boolean(errors.length)"
            :danger-text="errors[0]"
          />
          <feather-icon
            :class="
              errors.length > 0
                ? 'signup__card--password-eye-error'
                : 'signup__card--password-eye'
            "
            :icon="!showPassword ? 'EyeOffIcon' : 'EyeIcon'"
            @click="() => (showPassword = !showPassword)"
          />
        </ValidationProvider>

        <ul>
          <li class="signup__card--checkbox-wrapper">
            <vs-checkbox v-model="policy_and_privacy">
              <span>Concordo com as </span>
            </vs-checkbox>
            <a href="https://recrutei.com.br/privacidade-e-seguranca" target="blank"
              >Políticas de Privacidade</a
            >
            <span v-if="policy_error" class="signup__checkbox-warning"
              >Clique no quadro para declarar que está de acordo com a política de
              privacidade</span
            >
          </li>
          <li class="signup__card--checkbox-wrapper">
            <vs-checkbox v-model="conditions_terms">
              <span>Concordo com as </span>
            </vs-checkbox>
            <a href="https://recrutei.com.br/termos-de-uso" target="blank"
              >Termos de uso</a
            >
            <span v-if="condition_error" class="signup__checkbox-warning"
              >Clique no quadro para informar que está de acordo com os termos de
              serviço</span
            >
          </li>
        </ul>

        <button
          type="submit"
          :style="{ opacity: invalid ? 0.3 : 1 }"
          class="signup__card--submit bg-primary"
        >
          Iniciar candidatura
        </button>
      </ValidationObserver>
      <p class="signup__card--account">
        Já tem uma conta?
        <vs-button
          type="flat"
          class="signup__card--account-link p-0"
          @click="handleRedirect"
        >
          Fazer login
        </vs-button>
      </p>
    </div>
    <vs-popup title="" :active.sync="popupActivity">
      <div class="conditions__container">
        <img
          src="@/assets/images/logo/logo.png"
          alt="Recrutei logo"
          class="conditions__logo"
        />
        <p class="conditions__title">
          Atualizamos nossos Termos de uso e Política de privacidade
        </p>
        <p class="conditions__description">
          Entendemos que você está de acordo com os novos termos de privacidade assim que
          clicar em concordo com os novos termos e continuar utilizando a Experiência de
          Talentos. Para consultar os termos, é só clicar nos links:
          <a
            href="https://recrutei.com.br/termos-de-uso"
            target="_blank"
            class="conditions__link"
            >Termos e condições de uso</a
          >
          e
          <a
            href="https://recrutei.com.br/privacidade-e-seguranca"
            target="_blank"
            class="conditions__link"
            >Política de privacidade</a
          >.
        </p>
        <vs-divider position="center"> </vs-divider>
        <ul>
          <li class="checkbox-wrapper">
            <vs-checkbox v-model="whatsapp_policy_and_privacy">
              <span>Concordo com as </span>
            </vs-checkbox>
            <a href="https://recrutei.com.br/privacidade-e-seguranca" target="blank"
              >Políticas de Privacidade</a
            >
            <span v-if="policy_error" class="checkbox-warning"
              >Clique no quadro para declarar que está de acordo com a política de
              privacidade</span
            >
          </li>
          <li class="checkbox-wrapper">
            <vs-checkbox v-model="whatsapp_conditions_terms">
              <span>Concordo com as </span>
            </vs-checkbox>
            <a href="https://recrutei.com.br/termos-de-uso" target="blank"
              >Termos de uso</a
            >
            <span v-if="condition_error" class="checkbox-warning"
              >Clique no quadro para informar que está de acordo com os termos de
              uso</span
            >
          </li>
        </ul>
        <vs-button @click="handleWhatsApp">Continuar com cadastro</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { keys, get } from "lodash";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import * as Sentry from "@sentry/vue";
import { identifyTalent, trackNewApplication } from "@/services/posthog";

export default {
  name: "sign-up-form",
  components: {
    ValidationProvider,
    ValidationObserver,
    VuePhoneNumberInput,
  },
  data: () => ({
    whatsapp_policy_and_privacy: false,
    whatsapp_conditions_terms: false,
    condition_error: false,
    policy_error: false,
    popupActivity: false,
    email: "",
    username: "",
    password: "",
    confirmEmail: "",
    conditions_terms: false,
    policy_and_privacy: false,
    api_callback_errors: {},
    showPassword: false,
    telephone: "",
    ssn: "",
  }),
  methods: {
    ...mapActions("step", ["updateCurrentStep"]),
    handleRedirect() {
      const { query, params } = this.$router.history.current;

      this.$router.push({
        name: "signin",
        params,
        query,
      });
    },
    phoneMask() {
      return this.telephone && this.telephone.length > 14
        ? "(##) #####-####"
        : "(##) ####-#####?";
    },
    handleWhatsApp() {
      if (this.whatsapp_policy_and_privacy && this.whatsapp_conditions_terms) {
        this.popupActivity = false;
        const { company_label, vacancy_id } = this.$router.history.current.params;
        const { utm_source, clickid, utm_campaign, utm_medium } = this.$router.history.current.query;
        window.open(
          `https://wa.me/553493389648?text=Ol%C3%A1,%20quero%20me%20candidatar%20em:%20https://jobs.recrutei.com.br/${company_label}/vacancy/${vacancy_id}?utm_source=${utm_source}%26utm_medium=${utm_medium}%26utm_campaign=${utm_campaign}`,
          "_blank"
        );
      } else {
        if (!this.whatsapp_policy_and_privacy) this.policy_error = true;
        if (!this.whatsapp_conditions_terms) this.condition_error = true;
      }
      return;
    },
    handleCheckboxError(errors) {
      return errors.length === 0 && !this.policy_and_privacy;
    },
    shouldShowCompanyLogo() {
      return keys(this.company).length > 0;
    },
    optimizelyIsEnabled() {
      if (!this.company) return false;
      
      return (
        this.company.has_bot && this.$router.history.current.params.vacancy_id !== undefined
      );
    },
    optimizelyIsEnabledSsn() {
      const params = this.$router.history.current.params;

      return !this.$optimizely.isFeatureEnabled("whatsapp_application", "", {
        slugs: params.company_label,
      });
    },
    async handleRegister() {
      if (!this.policy_and_privacy) {
        this.policy_error = true;
      }

      if (!this.conditions_terms) {
        this.condition_error = true;
      }

      const isValid = await this.$refs.observer.validate();
      if (!isValid || !this.conditions_terms || !this.policy_and_privacy) return;

      Sentry.setUser({ username: this.username, email: this.email });

      let payload = {
        name: this.username,
        email: this.email,
        password: this.password,
        password_confirmation: this.password,
        conditions_terms: this.conditions_terms,
        policy_and_privacy: this.policy_and_privacy,
        telephone: this.telephone,
        city: "",
        ssn: this.ssn,
      };

      const { utm_source, clickid, utm_campaign, utm_medium } = this.$router.history.current.query;

      sessionStorage.setItem("utm_source", utm_source);

      if (utm_source !== null && utm_source !== "") {
        payload = {
          ...payload,
          channel: utm_source,
        };
      }

      if (clickid !== null && clickid !== "") {
        payload = {
          ...payload,
          clickid: clickid,
        };
      }

      if (utm_campaign !== null && utm_campaign !== "") {
        payload = {
          ...payload,
          utm_campaign: utm_campaign,
        };
      }

      if (utm_medium !== null && utm_medium !== "") {
        payload = {
          ...payload,
          utm_medium: utm_medium,
        };
      }

      const { company_label, vacancy_id } = this.$router.history.current.params;

      let url = "";

      if (company_label === "anonima") {
        url = `/api/v2/talents/anonimo/register/${vacancy_id}`;
      } else {
        url =
          vacancy_id !== undefined
            ? `/api/v2/talents/${company_label}/register/${vacancy_id}`
            : `/api/v2/talents/${company_label}/register`;
      }

      this.$vs.loading({
        text: "Salvando...",
      });

      this.$http
        .post(url, payload)
        .then(async (response) => {
          this.$vs.loading.close();

          const label = this.$router.history.current.params.company_label;

          if (label === "anonima") {
            //TODO: Retornar o application_id na resposta da API
            const { token } = response.data;

            this.$store.dispatch("auth/addToken", {
              token,
            });

            localStorage.setItem("userToken", response.data.token);

            const { talent } = response.data.data;

            this.$store.dispatch("auth/addUser", {
              user: {
                talent,
              },
            });

            // PostHog identify (anonima) - identificador por email
            identifyTalent(this.email, {
              email: this.email,
              name: this.username,
              last_company_label: this.$router.history.current.params.company_label,
            });

            // Track new_application sempre; se não houver vaga será "Banco de Talentos"
            const { vacancy_id, company_label } = this.$router.history.current.params;
            trackNewApplication({
              vacancy_id,
              company_label,
              channel: (utm_source && utm_source !== "") ? utm_source : undefined,
            });
          } else {
            const { application_id } = response.data;
            const { company, talent } = response.data.data;

            this.$store.dispatch("auth/addUser", {
              user: {
                talent,
              },
            });

            this.$store.dispatch("auth/addToken", {
              token: response.data.token,
            });

            this.$store.dispatch("company/addId", {
              company,
            });

            localStorage.setItem("userToken", response.data.token);
            sessionStorage.setItem("@recrutei:talent:application_id", application_id);

            // PostHog identify - identificador por email
            identifyTalent(this.email, {
              email: this.email,
              name: this.username,
              last_company_label: this.$router.history.current.params.company_label || (company && company.label),
            });

            // Track new_application sempre; se não houver vaga será "Banco de Talentos"
            const { vacancy_id, company_label } = this.$router.history.current.params;
            trackNewApplication({
              vacancy_id,
              company_id: company && company.id,
              company_name: company && company.name,
              company_label: company_label || (company && company.label),
              channel: (utm_source && utm_source !== "") ? utm_source : undefined,
            });
          }
          const { vacancy_id, company_label } = this.$router.history.current.params;

          this.$router.push({
            name: "step-basic-info",
            params: {
              vacancy_id,
              company_label,
            },
          });

          await this.updateCurrentStep({ order: 0 });
        })
        .catch((error) => {
          this.$vs.loading.close();

          const { data, status } = error.response;

          if (status === 422 && data !== undefined && data.errors.length) {
            this.api_callback_errors = Object.assign(
              {},
              {
                email: data.errors[0].key === "email" ? data.errors[0].errors : null,
                ssn: data.errors[0].key === "ssn" ? data.errors[0].errors : null,
              }
            );
          }
        });
    },
  },
  computed: {
    ...mapState("company", ["company"]),

    logo() {
      const { company } = this.$store.state.company;
      return company.logo_url;
    },

    isAnonimous() {
      const label = get(this.$router, "history.current.params.company_label", null);
      return label === "anonima";
    },
  },
  watch: {
    policy_and_privacy(value) {
      if (value) this.policy_error = false;
    },
    conditions_terms(value) {
      if (value) this.condition_error = false;
    },
    whatsapp_policy_and_privacy(value) {
      if (value) this.policy_error = false;
    },
    whatsapp_conditions_terms(value) {
      if (value) this.condition_error = false;
    },
  },
  created() {
    if (!this.company) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
    this.$validator.extend("cpf", {
      getMessage: (field) => `O ${field} informada não é valido`,
      validate: (value) => {
        const cpfReg = /[0-9]{3}\.[0-9]{3}\.[0-9]{3}-?[0-9]{2}/;
        if (!value.match(cpfReg)) return false;

        const replaced = value.replace(/\./g, "").replace(/-/g, "");

        let sum = 0;
        let rest = 0;

        for (let i = 1; i <= 9; i++)
          sum += parseInt(replaced.substring(i - 1, i)) * (11 - i);
        rest = (sum * 10) % 11;

        if (rest == 10 || rest == 11) rest = 0;
        if (rest != parseInt(replaced.substring(9, 10))) return false;

        sum = 0;

        for (let i = 1; i <= 10; i++)
          sum += parseInt(replaced.substring(i - 1, i)) * (12 - i);
        rest = (sum * 10) % 11;

        if (rest == 10 || rest == 11) rest = 0;
        if (rest != parseInt(replaced.substring(10, 11))) return false;

        return true;
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.new-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  margin-top: 40px;
}
.signup__card {
  width: 360px;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 16px;

  h2 {
    text-align: center;
  }

  &--logo {
    max-width: 130px;
    max-height: 150px;
    margin: 0 auto;
    margin-bottom: 05px;
    margin-top: 10px;
    object-fit: contain;
  }

  &--title {
    font-size: 18px;
    margin: 20px 0;
  }

  &--input {
    width: 100%;
  }

  &--password-eye {
    position: absolute;
    top: -30px;
    right: -92%;
    transition-delay: 0s;
    svg {
      cursor: pointer;
      width: 18px;
      color: gray !important;
    }
  }

  &--password-eye-error {
    position: absolute;
    top: -48px;
    right: -90%;
    z-index: 100;
    transition-delay: 0s;
    svg {
      cursor: pointer;
      width: 18px;
      color: gray !important;
    }
  }

  &--submit {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0.85rem 2.5rem;
    color: white;
    font-size: 16px;
    font-weight: 200;
    border: 0px;
    border-radius: 5px;

    margin: 20px 0 20px 0;
    transition: color 0.5s;

    &:hover {
      color: #fcfcfc;
      cursor: pointer;
    }
  }

  &--account {
    font-size: 14px;
    text-align: center;

    a {
      font-weight: 500;
    }
  }

  &--account-link {
    font-size: 14px;
    padding: 0;
    margin-left: 4px;
  }

  &--checkbox-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    width: 100%;
    margin-bottom: 10px;

    span {
      font-size: 12px;
    }

    a {
      font-size: 12px;
    }
  }

  &--whatsapp {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #25d366;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 8px 16px;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;

    svg {
      width: 18px;
      height: 18px;
    }
  }
}

.conditions__container {
  display: flex;
  flex-direction: column;
  padding: 10px;

  hr {
    border-color: red;
  }
}

.conditions__logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin: 0 auto;
}

.conditions__title {
  text-align: center;
  margin-bottom: 20px;
}

.conditions__description {
  text-align: center;
  letter-spacing: 0.1px;
}

.checkbox-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 10px;

  span {
    font-size: 12px;
  }

  a {
    font-size: 12px;
  }
}

.checkbox-wrapper:nth-of-type(2) {
  margin-bottom: 30px;
}

.checkbox-warning {
  font-size: 9.1px !important;
  color: #ea5455;
  margin: 10px 0;
}
</style>
